import React from "react"

import { Pullquote } from "@components/type"

const Main = ({ theme }) => (
  <>
    <h3>Community Counselling</h3>
    <p>
      Community Counsellors are trained volunteers who are available for support
      and assistance during Food Bank open hours. There are currently 10 active
      volunteers, speaking 5 languages. This year, Counsellors had 2940 contacts
      with people seeking assistance and referrals. 825 of these were new
      households, who had never been to N2N before. Nearly 4,000 referrals to
      services were made.
    </p>
    <Pullquote>
      Nearly <strong>4,000</strong> referrals to services were made.
    </Pullquote>
  </>
)

export default Main
